'use client'

import { useTranslations } from 'next-intl'

import { MobilePeriodPicker } from '@/features/room-search'
import { Slot } from '@/shared/lib'
import { Icon, ScreenOverlay, TextField } from '@/shared/ui'
import { MobileHeader } from '@/widgets/common'

import { OverlayContent } from './content'
import { useMobileSearchBar } from '../lib/mobile-search-bar'

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const MobileSearchOverlay = ({ isOpen, onClose }: Props) => {
  const t = useTranslations()

  const {
    keyword,
    handleKeywordChange,
    handleKeywordReset,
    isPeriodPickerOpen,
    setIsPeriodPickerOpen,
    showSearchWithoutDate,
    handleDateRangeChange,
    handleSearchWithoutDate,
    handleHistoryClick,
    handleClose,
    handleKeywordSelect,
    tab,
    handleTabChange,
  } = useMobileSearchBar({ isOpen, onClose })

  return (
    <ScreenOverlay.Content className="flex flex-col">
      <MobileHeader.Root>
        <Slot name="left">
          <MobileHeader.Back onClick={handleClose} />
        </Slot>
        <Slot name="title">{t('search_panel.title')}</Slot>
      </MobileHeader.Root>
      <ScreenOverlay.Title className="sr-only">
        {t('search_panel.title')}
      </ScreenOverlay.Title>
      <ScreenOverlay.Description className="sr-only">
        {t('search_panel.description')}
      </ScreenOverlay.Description>

      <MobilePeriodPicker
        open={isPeriodPickerOpen}
        onOpenChange={setIsPeriodPickerOpen}
        onChange={handleDateRangeChange}
        showSearchWithoutDate={showSearchWithoutDate}
        onSearchWithoutDate={handleSearchWithoutDate}
      >
        <span className="sr-only" />
      </MobilePeriodPicker>

      <div className="gradient-bottom-border mobile">
        <div className="flex flex-col px-4">
          <TextField
            name="keyword"
            type="search"
            value={keyword}
            onChange={handleKeywordChange}
            onReset={handleKeywordReset}
            placeholder={t('map.search.location.placeholder')}
            autoFocus
            className="typo-body2 h-14 border-none bg-transparent"
            padding={{ x: 0, y: 16 }}
            fullWidth
          >
            <Slot name="left">
              <Icon
                name="search"
                size={24}
                className="text-black"
                strokeWidth={1.5}
              />
            </Slot>
          </TextField>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto overscroll-contain px-4 py-6">
        <OverlayContent
          keyword={keyword}
          tab={tab}
          onTabChange={handleTabChange}
          onHistoryClick={handleHistoryClick}
          onLocationSelect={handleKeywordSelect}
        />
      </div>
    </ScreenOverlay.Content>
  )
}
